exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".chapter-management-app .segmented-table img {\n  display: block;\n  max-width: 100px;\n  max-height: 100px;\n}\n", ""]);
